// AI-CONTEXT: See docs/patterns.md#data-memoised-module-fetch
const EXPORT_URL = 'https://europe-west1-deccos-app.cloudfunctions.net/exportTemplateData';

/** @type {Promise<object> | null} */
let inFlight = null;

/**
 * Fetches the LiveReport template data dump from the exportTemplateData Cloud Function.
 *
 * The promise is memoised at module level so all widgets/dropdowns/contexts on a page
 * share a single network request. A failed request is NOT memoised — the next caller
 * gets a fresh attempt.
 *
 * @returns {Promise<object>}  Parsed response body (`{ companyId, generatedAt, data, errors? }`)
 */
export const fetchTemplateData = () => {
    if (inFlight) return inFlight;

    inFlight = fetch(EXPORT_URL)
        .then((res) => {
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return res.json();
        })
        .catch((err) => {
            inFlight = null;
            throw err;
        });

    return inFlight;
};
